export function getQueryParam(name) {
    const queryString = window.location.search;

    const params = new URLSearchParams(queryString);

    return params.get(name);
}

export function setUrlParameter(name, value) {
    const currentUrl = window.location.href;

    const url = new URL(currentUrl);

    url.searchParams.set(name, value);

    window.history.pushState({ path: url.href }, '', url.href);
}
